import { useCallback } from 'react'
import { useTheme } from '@mui/material'

type SignatureMode = 'gmail' | 'render'

export function useGoogleSignature(currentUser: any, activeUser: any, mode: SignatureMode) {
  const theme = useTheme()

  return useCallback(() => {
    const title = currentUser?.title || 'No Title'
    const phone =
      currentUser?.phone || (activeUser?.user?.profile?.phone && activeUser?.user?.profile?.phone !== '')
        ? activeUser?.user?.profile?.phone
        : '000-000-0000'

    const linkedin = currentUser?.linkedIn ?? ''
    const photo = currentUser?.image_512 || 'No Image'
    const userName = currentUser?.name || 'No Name'
    const userEmail = currentUser?.email || 'No Email'

    const phoneDigits = phone.replace(/\D/g, '')
    const fullDigits = phoneDigits.length === 10 ? `1${phoneDigits}` : phoneDigits
    const telLink = `+${fullDigits}`
    const phoneSplit = [phoneDigits.slice(0, 3), phoneDigits.slice(3, 6), phoneDigits.slice(6, 10)]

    const textColor = mode === 'gmail' ? '#333333' : theme.palette.text.primary

    return /* html */ `
    <table cellpadding="1" cellspacing="1" style="font-family: Roboto, sans-serif; font-size: 16px; line-height: 1.4;">
      <tr>
        <td style="padding-right: 12px;" valign="top">
          <img src="${photo}" alt="${userName} Headshot" width="100" style="border-radius: 5%; display: block;" />
        </td>
        <td valign="top">
          <div style="color: ${textColor}; font-weight: bold; font-size: 16px;">${userName}</div>
          <div style="margin-top: 2px; color: ${textColor}; font-weight: bold; font-size: 14px;">${title}</div>
          <div style="margin-top: 6px; font-weight: bold; font-size: 11px;">
            <a href="tel:${telLink}"
               style="color: ${textColor} !important; text-decoration: none !important; font-size: inherit !important; display: inline-block;">
              <span style="color: ${textColor} !important; text-decoration: none !important;">
                ${phoneSplit[0]}<span style="color: #ff536f;">.</span>${phoneSplit[1]}<span style="color: #ff536f;">.</span>${phoneSplit[2]}
              </span>
            </a>
          </div>
          <div style="margin-top: 3px; font-weight: bold; font-size: 11px;">
            <a href="mailto:${userEmail}"
               style="color: ${textColor}; text-decoration: none !important;">
              <span style="color: ${textColor}; text-decoration: none !important;">${userEmail}</span>
            </a>
          </div>
          <div style="margin-top: 3px; font-size: 11px; font-weight: bold;">
            <a href="https://gromarketing.com"
               style="color: ${textColor}; text-decoration: none !important;">
              <span style="color: ${textColor}; text-decoration: none !important;">Website</span>
            </a>
            <span style="color: #ff536f;"> | </span>
            <a href="${linkedin}"
               style="color: ${textColor}; text-decoration: none !important;">
              <span style="color: ${textColor}; text-decoration: none !important;">LinkedIn</span>
            </a>
            <span style="color: #ff536f;"> | </span>
            <a href="https://instagram.com/gromarketing"
               style="color: ${textColor}; text-decoration: none !important;">
              <span style="color: ${textColor}; text-decoration: none !important;">Instagram</span>
            </a>
          </div>
        </td>
      </tr>
    </table>
    `.trim()
  }, [currentUser, activeUser, mode, theme.palette.text.primary])
}
